<template>
  <ModalTemplate
    titulo="Redefinição de senha"
    :visivel="visivel"
    :botoes="botoesRodape"
    :largura-modal="435"
    @fechar-modal="fecharModal"
    @pressionar-botao="selecionarAcao"
  >
    <template #body>
      <EcdtInput 
        label="Confirme o seu e-mail"
        placeholder="Digite o seu e-mail"
        :value="emailUsuario"
        required
        required-text="Adicione um e-mail"
        :validator="UtilsService.validateEmail"
        validator-text="E-mail com formato inválido"
        type="email"
        @erro="(e) => botoesRodape[1].desabilitado = e"
        @update="(e) => emailUsuario = e"
      />
    </template>
  </ModalTemplate>
</template>

<script>
import RequestService from '@/services/RequestService';
import Constants from '@/services/Constants';
import UtilsService from '@/services/Utils.js';
import ModalTemplate from '@/ecdt-components/modals/ModalTemplate.vue';
import EcdtInput from '@/ecdt-components/inputs/EcdtInput.vue';

export default {
  components: {
    ModalTemplate,
    EcdtInput
  },
  props: {
    visivel: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      UtilsService,
      emailUsuario: '',
      botoesRodape: [
        {
          texto: 'Cancelar',
          valor: 'cancelar',
          estilo: 'botao-secundario',
        },
        {
          texto: 'Enviar e-mail de recuperação',
          valor: 'enviar',
          estilo: 'botao-primario',
          desabilitado: true,
          estiloDesabilitado: 'botao-desativado tw-not-allowed'
        }
      ]
    }
  },
  methods: {
    enviarEmailRedefinicao(emailConf) {
      const forgotPasswordOptions = {
        request: {
          url: Constants.api.forgot_password + '?email=' + emailConf
        }
      };

      RequestService().getRequest(forgotPasswordOptions);
      this.$emit('senha-redefinida');
    },
    fecharModal() {
      this.$emit('fechar-modal');
    },
    selecionarAcao(acao) {
      if (acao === 'cancelar') {
        this.fecharModal();
      } else if (acao === 'enviar') {
        this.enviarEmailRedefinicao(this.emailUsuario);
      }
    }
  }
}
</script>
